import Axios from 'axios'

const axios = Axios.create({
    baseURL: process.env.NEXT_PUBLIC_BACKEND_URL,
})

axios.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
        const accessToken = localStorage.getItem('access_token')
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
    }

    return config
})

export default axios
